// extracted by mini-css-extract-plugin
module.exports = {"\t":"Login__9__RsQjE","forgot":"Login_forgot__otmK1"};